import script from "./ProductContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductContent.vue?vue&type=script&setup=true&lang=ts"

import "./ProductContent.vue?vue&type=style&index=0&id=605435d9&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-605435d9"]])

export default __exports__